import React from "react";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import Section from "../Section";
import DepartmentSectionStyle3 from "../Section/DepartmentSection/DepartmentSectionStyle3";
import BannerSectionStyle6 from "../Section/BannerSection/BannerSectionStyle6";
import { pageTitle } from "../../helpers/PageTitle";
const departmentData = [
  {
    iconUrl: "images/departments/igd.svg",
    title: "Instalasi Gawat Darurat",
    subTitle:
      "IGD melayani keadaan darurat medis, baik kasus trauma maupun non-traumatis untuk mencegah kematian dan kecacatan penderita.",
    href: "",
  },
  {
    iconUrl: "images/departments/lab.svg",
    title: "Laboratorium",
    subTitle:
      "Laboratorium Rumah Sakit Mutira Bunda adalah Unit Layanan Penunjang Medis yang bertugas membantu menegakkan diagnosis",
    href: "",
  },
  {
    iconUrl: "images/departments/poli.svg",
    title: "Poliklinik",
    subTitle:
      "Poliklinik yang menyediakan layanan medis untuk pasien yang tidak membutuhkan rawat inap",
    href: "",
  },
  {
    iconUrl: "images/departments/mcu.svg",
    title: "Medical Check Up",
    subTitle:
      "Medical check up adalah serangkaian tes dan evaluasi medis yang dilakukan sebagai tindakan pencegahan dan pemantauan kesehatan umum.",
    href: "",
  },
  {
    iconUrl: "images/departments/fisio.svg",
    title: "Fisioterapi",
    subTitle:
      "Layanan fisioterapi, juga dikenal sebagai terapi fisik, adalah bidang perawatan kesehatan untuk mengobati cedera, memulihkan fungsi fisik",
    href: "",
  },
  {
    iconUrl: "images/departments/inap.svg",
    title: "Rawat Inap",
    subTitle:
      "Hospitalisasi adalah salah satu fitur penting yang dimiliki oleh rumah sakit.",
    href: "",
  },
  {
    iconUrl: "images/departments/farmasi.svg",
    title: "Farmasi",
    subTitle:
      "Farmasi di dalam rumah sakit mencakup berbagai komponen yang mendukung pengelolaan obat dan penyediaan pelayanan kefarmasian yang efektif",
    href: "",
  },
  {
    iconUrl: "images/departments/bedah.svg",
    title: "Ruang Operasi",
    subTitle:
      "Ruang Operasi adalah fasilitas utama di dalam rumah sakit yang digunakan untuk melakukan prosedur bedah",
    href: "",
  },
];

export default function Layanan() {
  pageTitle("Fasilitas & Layanan");
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/departments/banner_bg_3.svg"
        imgUrl="/images/departments/layanan.png"
        title="Fasilitas & Layanan<br>RS Mutiara Bunda"
        subTitle="Kami memberikan yang terbaik untuk kesehatan anda"
      />
      <Section bottomMd={140} bottomLg={100} bottomXl={60}>
        <DepartmentSectionStyle3 data={departmentData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle6
          imgUrl="/images/departments/banner_img_2.png"
          title="Jangan Biarkan Kesehatanmu Terabaikan!"
          subTitle="Jadwalkan janji temu dengan profesional medis berpengalaman kami hari ini!"
        />
      </Section>
    </>
  );
}
